module.exports = __webpack_public_path__ + "static/wiring-98a37bb149f07a15b9bd0c54abdc4a28.png";